import { ApiError } from "pages/admin-app/shared/models/response/api-errors";
import { useQuery } from "@tanstack/react-query";
import { GetEndUserResponse } from "../models/response/get-end-user-response";
import { getEndUser } from "../services/end-user-service";

interface Props {
  endUserId: number | string;
}

export function useEndUser({ endUserId }: Props) {
  const { data, error, isLoading, isError, refetch } = useQuery<
    GetEndUserResponse,
    ApiError
  >({
    queryKey: ["endUser", endUserId],
    queryFn: () => getEndUser({ endUserId }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
  };
}
